import React from 'react';
import type { AssignedColumnProps } from './types';
import { Label } from '@easylife365/react';
import { useQuery } from '@tanstack/react-query';
import { graphQueries } from '../../../api/graph.api';

const AssignedColumn: React.FC<AssignedColumnProps> = ({ id }) => {
  const { isPending, data: user } = useQuery({
    ...graphQueries.getUserById(id ?? ''),
    enabled: !!id,
  });

  if (isPending) return null;

  const value = user?.mail ?? user?.userPrincipalName ?? '--';
  return <Label label={value} title={value?.toString()} />;
};

export default AssignedColumn;
